export interface ScoreEntry {
  score: number;
  date: string;
  mode: string;
}

const SCORE_KEY = 'viva-brick-breaker-scores-v1';
const HIGH_KEY = 'viva-brick-breaker-high-v1';

export function getHighScore(): number {
  const value = Number(localStorage.getItem(HIGH_KEY) || 0);
  return Number.isFinite(value) ? value : 0;
}

export function setHighScore(score: number): void {
  if (score > getHighScore()) localStorage.setItem(HIGH_KEY, String(score));
}

export function getScores(): ScoreEntry[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(SCORE_KEY) || '[]') as ScoreEntry[];
    return Array.isArray(parsed) ? parsed.slice(0, 10) : [];
  } catch {
    return [];
  }
}

export function saveScore(score: number, mode: string): ScoreEntry[] {
  const entries = [...getScores(), { score, mode, date: new Date().toLocaleDateString('zh-CN') }]
    .sort((a, b) => b.score - a.score)
    .slice(0, 10);
  localStorage.setItem(SCORE_KEY, JSON.stringify(entries));
  setHighScore(score);
  return entries;
}
